import {
    Backdrop,
    Button,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    CircularProgress,
    Container,
    Divider,
    Grid,
    IconButton,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    createTheme,
    Dialog, DialogTitle, DialogActions, DialogContent,
    List, ListItem, ListItemIcon, ListItemText,
    Typography,
    TableSortLabel
} from '@material-ui/core';
import Alert from 'src/components/Alert';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useState, useEffect } from 'react';
import { getUser } from 'src/utils/Common';
import Page from 'src/components/Page';
import ListItemButton from '@material-ui/core/ListItemAvatar';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import CloseIcon from '@material-ui/icons/Close';
import FolderIcon from '@material-ui/icons/Folder';
import Tarihce from 'src/views/History';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'src/utils/axios';
import moment from 'moment';
import ServiceDigitalForms from 'src/components/ServiceDigitalForms';
import ServiceDigitalFormsPrint from 'src/components/ServiceDigitalFormsPrint';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import BlockIcon from '@material-ui/icons/Block';

const materialTheme = createTheme({
    palette: {
        primary: {
            contrastText: '#FF9800',
            dark: '#424242',
            main: '#424242',
            light: '#424242'
        }
    }
});

const localeMap = {
    tr: trLocale
};

function LaborManagement() {
    const useStyles = makeStyles(theme => ({
        root: {
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3)
        },
        rootlist: {
            width: '100%',
            backgroundColor: theme.palette.background.paper,
            position: 'relative',
            overflow: 'auto',
            maxHeight: 550
        },
        rootlistsag: {
            width: '100%',
            backgroundColor: theme.palette.background.paper,
            position: 'relative',
            overflow: 'auto',
            maxHeight: 500
        },

        cardBolum: {
            maxHeight: 700,
            minHeight: 700,
            width: '100%'
        },
        table: {
            minWidth: 650
        },
        content: {
            minHeight: 550
        },
        chatSection: {
            width: '100%'
        },
        avatar: {
            cursor: 'pointer',
            width: 40,
            height: 40
        },
        headBG: {
            backgroundColor: '#e0e0e0'
        },
        borderRight500: {
            borderRight: '1px solid #e0e0e0'
        },
        messageArea: {
            overflowY: 'auto'
        },
        button: {
            margin: theme.spacing(1)
        },
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff'
        },
        actionsCCFile: {
            justifyContent: 'flex-end'
        },
        responsiveContainer: {
            marginTop: theme.spacing(3),
            [theme.breakpoints.between('md', 'lg')]: {
                maxHeight: '70vh',
                overflowX: 'hidden',
                overflowY: 'scroll'
            },
            [theme.breakpoints.down('sm')]: {
                maxHeight: '60vh',
                overflow: 'scroll'
            }
        },
        action: {
            display: 'flex',
            alignItems: 'center',
            marginLeft: 'auto',
            paddingLeft: 16,
            marginRight: 10,
            borderRadius: 10,
            [theme.breakpoints.down('xs')]: {
                width: '100%',
                margin: 0
            }
        }
    }));

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;

    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const SessionUser = getUser();
    const [anketBitti, setAnketBitti] = useState(false);
    const [printAnket, setPrintAnket] = useState(false);
    const [singlePopUp, setSinglePopUp] = useState(false);
    const [yorumAciklama, setYorumAciklama] = useState('');

    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    const [durum, setDurum] = useState([]);
    const [selectedDurum, setSelectedDurum] = useState([]);

    const [talepEdilmeBaslangicTarihi, setTalepEdilmeBaslangicTarihi] = useState(
        new Date().toString()
    );

    const [talepEdilmeBitisTarihi, setTalepEdilmeBitisTarihi] = useState(
        new Date().toString()
    );

    const formattedBaslangicDate = moment(talepEdilmeBaslangicTarihi).format('MM-DD-YYYY')
    const formattedBitisDate = moment(talepEdilmeBitisTarihi).format('MM-DD-YYYY')

    const [generalData, setGeneralData] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedDurumId, setSelectedDurumId] = useState(0);
    const [tarihcePopUp, setTarihcePopUp] = useState(false);
    const [filePopUp, setFilePopUp] = useState(false);
    const [fileList, setFileList] = React.useState([]);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('SURECTIPI');
    const sortedRows = (stableSort(generalData, getComparator(order, orderBy)));
    const [formTypes, setFormTypes] = useState([]);
    const [anketGoster, setAnketGoster] = useState(false);
    const [anketData, setAnketData] = useState({});
    const [formData, setFormData] = useState({});
    const [readOnly, setReadOnly] = useState(false);
    const [mesaj, setMesaj] = useState('');
    const [documents, setDocuments] = useState([]);
    const [Required, setRequired] = useState(false);

    useEffect(() => {
        getServiceFormCategories();
        GetApolloHizmetForm();
        getLaborSteps();
    }, []);


    const getLaborSteps = () => {
        axios.get("/getLaborSteps").then((response) => {
            setDurum(response.data);
        })
    }

    function GeneralDataFiltreleAra() {
        if (selectedDurum.length <= 0) {
            setresponseMessage('Lütfen önce seçim yapınız!!!...')
            setUyariTip('error')
            setUyari(true)
            return
        }

        var DurumlarList = [];
        selectedDurum.map((i) => {
            DurumlarList.push(i.DURUM_ID)
        })

        const data = {
            SONONAYVEREN: DurumlarList.toString(),
            BASLANGICTARIHI: formattedBaslangicDate,
            BITISTARIHI: formattedBitisDate,
        }

        axios.get(`GetApolloHizmetForm/${data.SONONAYVEREN}/${data.BASLANGICTARIHI}/${data.BITISTARIHI}/${SessionUser.UserId}`).then((response) => {
            setGeneralData(response.data);
            setDocuments(response.data);
        })
    }


    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleYorum = (row) => {
        setSelectedIndex(row.ID);
        setTarihcePopUp(true);
    }


    const onComplete = (survey) => {
        setLoading(true);
        const data = {
            FormData: JSON.stringify(survey.data),
            FormType: 10,
            ServiceShopId: 0,
            UserId: SessionUser.UserId,
            Type: 5
        };
        const config = {
            headers: { 'Content-Type': 'application/json' }
        };
        axios.post(`/SetApolloForm`, data, config)
            .then((res) => {
                const response = res.data;
                if (response?.ErrorCode === "OK") {
                    handleAnketBitti(response.ErrorDescription);
                } else {
                    handleAnketBitti(response?.ErrorDescription || "Bir hata oluştu.");
                }
                setLoading(false);
            })
            .catch(() => {
                handleAnketBitti("Sunucuya bağlanılamadı.");
                setLoading(false);
            });
    };

    const handleAnketBitti = (MesajParam = "Form başarıyla kaydedildi.") => {
        setAnketBitti(true);
        setMesaj(MesajParam);
        GetApolloHizmetForm();
    };

    const GetApolloHizmetForm = () => {
        var DurumlarList = [];
        selectedDurum.map((i) => {
            DurumlarList.push(i.DURUM_ID)
        })

        const data = {
            SONONAYVEREN: DurumlarList.toString()
        }

        setLoading(true);
        axios.get(`GetApolloHizmetForm/${data.SONONAYVEREN}/${formattedBaslangicDate}/${formattedBitisDate}/${SessionUser.UserId}`).then((response) => {
            if (response.data) {
                setDocuments(response.data);
            } else {
                setDocuments([]);
            }
            setLoading(false);
        });
    }

    function descendingComparator(a, b, orderBy) {
        // Handle null values
        if (a[orderBy] === null && b[orderBy] !== null) {
            return 1; // Consider 'a' greater than 'b'
        } else if (a[orderBy] !== null && b[orderBy] === null) {
            return -1; // Consider 'b' greater than 'a'
        } else if (a[orderBy] === null && b[orderBy] === null) {
            return 0; // Both are null, consider them equal
        }
        if (typeof a[orderBy] === 'undefined' && typeof b[orderBy] !== 'undefined') {
            return 1; // Consider 'a' greater than 'b'
        } else if (typeof a[orderBy] !== 'undefined' && typeof b[orderBy] === 'undefined') {
            return -1; // Consider 'b' greater than 'a'
        } else if (typeof a[orderBy] === 'undefined' && typeof b[orderBy] === 'undefined') {
            return 0; // Both are null, consider them equal
        }

        // Handle comparison between string and integer values
        if (typeof a[orderBy] === 'number' && typeof b[orderBy] === 'string') {
            return 1; // Consider 'a' greater than 'b'
        } else if (typeof a[orderBy] === 'string' && typeof b[orderBy] === 'number') {
            return -1; // Consider 'b' greater than 'a'
        } else if (typeof a[orderBy] === 'number' && typeof b[orderBy] === 'number') {
            if (a[orderBy] < b[orderBy]) {
                return -1;
            }
            else if (a[orderBy] > b[orderBy]) {
                return 1;
            }
            else return 0;
        }

        return b[orderBy].localeCompare(a[orderBy]);


        // Compare non-null values using localeCompare
    }


    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        if (array.length === 0) {
            return array;
        }
        else {
            const stabilizedThis = array.map((el, index) => [el, index]);
            stabilizedThis.sort((a, b) => {
                const order = comparator(a[0], b[0]);
                if (order !== 0) {
                    return order;
                }
                return a[1] - b[1];
            });
            return stabilizedThis.map((el) => el[0]);
        }
    }

    const getServiceFormCategories = () => {
        setLoading(true);
        axios.get('getLaborFormCategories')
            .then((response) => {
                setFormTypes(response.data.FormTypes);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            }
            );
    }


    const handleAnketKapat = () => {
        setAnketGoster(false);
    }


    const handleCreateForm = () => {
        setAnketData(formTypes[0].Data);
        setAnketGoster(true);
        setReadOnly(false);
        setFormData({});
        setAnketBitti(false);
    }

    const handleSinglePopUp = (row) => {

        setSelectedIndex(row.ID);
        setSelectedDurumId(row.DURUM_ID);
        setSinglePopUp(true);
        setYorumAciklama('');
    }

    const handleSave = (caseValue) => {
        let hasError = false;

        if (!yorumAciklama) {
            setRequired(true);
            setSinglePopUp(true);
            hasError = true;
        }

        if (hasError) return;

        const data = [
            {
                Id: selectedIndex,
                Yorum: yorumAciklama,
                UserId: SessionUser.UserId,
                Role_Id: 0,
                Durum: selectedDurumId,
                Case: caseValue   // renamed variable
            }
        ];

        const config = {
            headers: { "Content-Type": "application/json" }
        };
        axios
            .post("SetApolloHizmetFormBasvuruOnay", data, config)
            .then((response) => {
                const res = response.data[0];

                setresponseMessage(res.ErrorDescription);
                setUyariTip(res.ErrorCode === "0" ? "success" : "error");
                setUyari(true);
                setLoading(false);
                setSinglePopUp(false);
                GetApolloHizmetForm();
                if (res.ErrorCode === "0") {
                    setRequired(false);
                }
            });
    };

    return (
        <Page className={classes.root}>
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                ></Alert>
            </Snackbar>
            <Container className={classes.container1} maxWidth="xl">
                <Card>
                    <CardHeader title="Hizmet/İşçilik Yönetimi" />
                    <Divider />
                    <CardContent>
                        <Grid container spacing={1} alignItems="center" style={{ marginBottom: '5px' }}>
                            {/* Durum */}
                            <Grid item xs={12} sm={3} lg={2}>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    id="multiple-limit-tags"
                                    fullWidth
                                    limitTags={1}
                                    disableCloseOnSelect
                                    value={selectedDurum}
                                    options={durum}
                                    getOptionLabel={option => (option.DURUM ? option.DURUM : '')}
                                    onChange={(event, newValue) => setSelectedDurum(newValue)}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option.DURUM}
                                        </React.Fragment>
                                    )}
                                    renderInput={params => (
                                        <TextField {...params} label="Durum" variant="outlined" />
                                    )}
                                />
                            </Grid>

                            {/* Başlangıç Tarihi */}
                            <Grid item xs={12} sm={3} lg={2}>
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap['tr']}>
                                        <KeyboardDatePicker
                                            fullWidth
                                            size="small"
                                            color="primary"
                                            inputVariant="outlined"
                                            label="Talep başlangıç tarihi"
                                            invalidDateMessage="Hatalı Tarih Formatı"
                                            format="dd.MM.yyyy"
                                            value={talepEdilmeBaslangicTarihi}
                                            onChange={date => setTalepEdilmeBaslangicTarihi(date)}
                                            KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </Grid>

                            {/* Bitiş Tarihi */}
                            <Grid item xs={12} sm={3} lg={2}>
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap['tr']}>
                                        <KeyboardDatePicker
                                            fullWidth
                                            size="small"
                                            color="primary"
                                            inputVariant="outlined"
                                            label="Talep bitiş tarihi"
                                            invalidDateMessage="Hatalı Tarih Formatı"
                                            format="dd.MM.yyyy"
                                            value={talepEdilmeBitisTarihi}
                                            onChange={date => setTalepEdilmeBitisTarihi(date)}
                                            KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </Grid>

                            {/* ARA butonu - bitiş tarihinin yanında */}
                            <Grid item xs={12} sm="auto" lg="auto">
                                <Button
                                    className={classes.action}
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => GeneralDataFiltreleAra()}
                                    style={{ height: '40px' }}
                                >
                                    ARA
                                    <SearchIcon style={{ marginLeft: '5px' }} />
                                </Button>
                            </Grid>

                            {/* YENİ FORM - en sağda */}
                            <Grid item xs={12} sm lg style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    className={classes.action}
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => handleCreateForm()}
                                    style={{ height: '40px' }}
                                >
                                    YENİ FORM OLUŞTUR
                                    <AddIcon style={{ marginLeft: '5px' }} />
                                </Button>
                            </Grid>
                        </Grid>
                        <Divider />
                        <TableContainer >
                            <Table stickyHeader aria-label="sticky table" size="small">
                                <TableHead style={{ overflowWrap: 'break-word' }}>
                                    <TableRow>
                                        <TableCell align="left"
                                            sortDirection={orderBy === 'SURECTIPI' ? order : false}>
                                            <TableSortLabel
                                                active={orderBy == 'SURECTIPI'}
                                                direction={orderBy === 'SURECTIPI' ? order : 'asc'}
                                                onClick={() => { handleRequestSort('SURECTIPI') }}>
                                                FormAdi
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="left"
                                            sortDirection={orderBy === 'SONONAYVEREN' ? order : false}>
                                            <TableSortLabel
                                                active={orderBy == 'SONONAYVEREN'}
                                                direction={orderBy === 'SONONAYVEREN' ? order : 'asc'}
                                                onClick={() => { handleRequestSort('SONONAYVEREN') }}>
                                                Son Onay Veren
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="left"
                                            sortDirection={orderBy === 'ONAYBEKLEYEN' ? order : false}>
                                            <TableSortLabel
                                                active={orderBy == 'ONAYBEKLEYEN'}
                                                direction={orderBy === 'ONAYBEKLEYEN' ? order : 'asc'}
                                                onClick={() => { handleRequestSort('ONAYBEKLEYEN') }}>
                                                Onay Beklenen
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="left"
                                            sortDirection={orderBy === 'SERVISBILGI' ? order : false}>
                                            <TableSortLabel
                                                active={orderBy == 'SERVISBILGI'}
                                                direction={orderBy === 'SERVISBILGI' ? order : 'asc'}
                                                onClick={() => { handleRequestSort('SERVISBILGI') }}>
                                                Açıklama
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="left">Yorumlar</TableCell>
                                        <TableCell align="left">Form</TableCell>
                                        <TableCell align="left">Formu Oluşturan</TableCell>
                                        <TableCell align="left">Onay/Red</TableCell>
                                        <TableCell align="left" />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {documents.length > 0 && documents.map((row) => (
                                        <TableRow
                                            key={row.ID}
                                            style={
                                                row.ID === selectedIndex
                                                    ? { backgroundColor: '#FF9800' }
                                                    : {}
                                            }
                                        >
                                            <TableCell align="left">{row.FORM_ADI}</TableCell>
                                            <TableCell align="left">{row.DURUM}</TableCell>
                                            <TableCell align="left">{row.SONRAKI_DURUM}</TableCell>
                                            <TableCell align="left">{row.FORM_ACIKLAMA}</TableCell>
                                            <TableCell align="left"> <IconButton
                                                size="small"
                                                onClick={() => handleYorum(row)}
                                                style={{ backgroundColor: '#19ecff', color: 'white' }}
                                            >
                                                <CommentOutlinedIcon />
                                            </IconButton>
                                            </TableCell>
                                            <TableCell align="left">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => {
                                                        setPrintAnket(false);
                                                        setReadOnly(true);
                                                        setAnketGoster(true);
                                                        setAnketData(row.AnketSoru);
                                                        setFormData(row.AnketCevap);
                                                        setAnketBitti(false);

                                                    }}>
                                                    <DescriptionIcon style={{ backgroundColor: '#FF9800', color: 'white' }} />
                                                </IconButton>
                                            </TableCell>
                                            <TableCell align="left">{row.ACIKLAMA}</TableCell>
                                            <TableCell align="left">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => {
                                                        handleSinglePopUp(row)
                                                    }}
                                                    style={{ backgroundColor: '#32CD32', color: 'white' }}
                                                >
                                                    <DoneAllIcon />
                                                </IconButton>
                                            </TableCell>
                                            <TableCell align="left" />
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CardContent>
                    <Dialog
                        open={tarihcePopUp}
                        fullWidth
                        maxWidth="lg"
                        onClose={event => setTarihcePopUp(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">Yorum Geçmişi</DialogTitle>
                        <DialogContent>
                            <Tarihce BasvuruId={selectedIndex} readonly={false} OpenClose={5} />
                        </DialogContent>
                        <DialogActions>
                            <IconButton
                                color="primary"
                                onClick={event => setTarihcePopUp(false)}
                                aria-label="upload picture"
                                component="span"
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={filePopUp}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        maxWidth="md"
                    >
                        <DialogContent>
                            <Grid container spacing={2}>
                                <List>
                                    {fileList?.length ? fileList?.map((item, index) => (
                                        <ListItem key={item.DOSYA_ID}>

                                            <ListItemButton
                                                style={{ display: 'flex', cursor: 'pointer' }}
                                            >
                                                <ListItemIcon>

                                                    <FolderIcon style={{ color: '#424242' }} />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={<Typography type="body2"> {item.DOSYA_ADI}</Typography>}
                                                    onClick={() => {
                                                        setNewWindowOpen(item);
                                                        // setShowFile(true)
                                                        // setSelectedFile(row)
                                                    }}
                                                />
                                                <ListItemText
                                                    primary={item.ContentType}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    )) : !loading ? "Dosya Bulunmamaktadır." : "Dosyalar Yükleniyor..."}
                                </List>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    setFilePopUp(false);
                                }}
                                aria-label="close"
                                component="span"
                                variant="contained"
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={anketGoster}
                        onClose={() => handleAnketKapat()}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth={true}
                        disableBackdropClick={true}
                        fullScreen={true}
                    >
                        <DialogContent>
                            {loading ?
                                <CircularProgress
                                    status={'loading'}
                                    style={{ marginLeft: '50%' }}
                                /> : anketBitti ? mesaj
                                    : printAnket ?
                                        <ServiceDigitalFormsPrint
                                            anketSoru={anketData}
                                            anketCevap={formData}
                                            formType={openedFormType}
                                        />
                                        :
                                        <>
                                            <ServiceDigitalForms
                                                anketSoru={anketData}
                                                anketCevap={formData}
                                                onComplete={onComplete}
                                                readonly={readOnly}
                                                serviceCodeQuestion={""}
                                                serviceNameQuestion={""}
                                                serviceFullNameQuestion={""}
                                                serviceShopFullName={""}
                                            />
                                        </>
                            }
                        </DialogContent>
                        <DialogActions className={classes.noDisplayInPrint}>
                            {
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => handleAnketKapat()}
                                    className={classes.button}
                                    endIcon={<CloseIcon>Close</CloseIcon>}
                                >
                                    Kapat
                                </Button>
                            }
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={singlePopUp}
                        fullWidth
                        maxWidth="sm"
                        onClose={() => setSinglePopUp(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle
                            id="alert-dialog-title"
                            style={{
                                textAlign: 'center',
                                position: 'relative',
                                padding: '16px 48px 16px 16px', // sağda çarpı için ekstra boşluk
                            }}
                        >
                            Onayla&Reddet
                            <IconButton
                                aria-label="close"
                                onClick={() => setSinglePopUp(false)}
                                style={{
                                    position: 'absolute',
                                    right: 12,
                                    top: 12,             // 8 yerine 12: çizgiden biraz uzak
                                    color: '#666',        // daha yumuşak gri
                                    backgroundColor: 'white', // çizgilerle çakışmasın diye beyaz arka plan
                                    borderRadius: '50%',
                                    boxShadow: '0 0 3px rgba(0,0,0,0.1)', // hafif gölge (isteğe bağlı)
                                }}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </DialogTitle>
                        <Card>
                            <CardContent className={classes.cardscontent}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12} lg={12}>
                                        <TextField
                                            size="small"
                                            id="desc"
                                            autoComplete="no"
                                            multiline
                                            error={yorumAciklama?.length > 0 ? false : Required}
                                            rows={10}
                                            value={yorumAciklama}
                                            onChange={(event) => setYorumAciklama(event.target.value)}
                                            fullWidth
                                            label="Yorum"
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <DialogActions>
                            <Button
                                color="secondary"
                                onClick={() => handleSave(1)}
                                aria-label="close"
                                component="span"
                                variant="contained"
                                endIcon={<BlockIcon />}
                                style={{ backgroundColor: '#ff0000', color: 'white' }}
                            >
                                Reddet
                            </Button>
                            <Button
                                color="secondary"
                                onClick={() => handleSave(0)}
                                aria-label="save"
                                component="span"
                                variant="contained"
                                style={{ backgroundCoslor: '#008000', color: 'white' }}
                                endIcon={<CheckCircleOutlineIcon />}
                            >
                                Onayla
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Card>
            </Container>
        </Page>
    );
}
export default LaborManagement;
